import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';

const SCROLL_HIDE_DELAY = 300;
const SCROLL_HIDDEN_CLASS = 'is-hidden';

/**
 * トップへ戻るボタンコンポーネント
 *
 * @element kd-back-to-top
 * @description マイページのSP用「トップへ戻る」ボタンの表示制御。
 *              スクロール中は非表示、スクロール停止後に表示。
 *              クリックでページトップへスムーススクロール。
 */
@customElement('kd-back-to-top')
export class KdBackToTop extends LitElement {
  createRenderRoot() {
    return this;
  }

  private scrollTimer: ReturnType<typeof setTimeout> | null = null;

  private handleScroll = (): void => {
    const btn = document.querySelector(SELECTORS.ACCOUNT.MYPAGE_BACK_TO_TOP) as HTMLElement | null;
    if (!btn) return;

    btn.classList.add(SCROLL_HIDDEN_CLASS);

    if (this.scrollTimer !== null) {
      clearTimeout(this.scrollTimer);
    }

    this.scrollTimer = setTimeout(() => {
      btn.classList.remove(SCROLL_HIDDEN_CLASS);
    }, SCROLL_HIDE_DELAY);
  };

  private handleClick = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  connectedCallback(): void {
    super.connectedCallback();

    window.addEventListener('scroll', this.handleScroll, { passive: true });

    const btn = document.querySelector(SELECTORS.ACCOUNT.MYPAGE_BACK_TO_TOP) as HTMLElement | null;
    if (btn) {
      btn.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    window.removeEventListener('scroll', this.handleScroll);

    if (this.scrollTimer !== null) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }

    const btn = document.querySelector(SELECTORS.ACCOUNT.MYPAGE_BACK_TO_TOP) as HTMLElement | null;
    if (btn) {
      btn.removeEventListener('click', this.handleClick);
    }
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-back-to-top': KdBackToTop;
  }
}
